import { Loading, useOrgUser } from '@cibo/profile'
import { useParamAsInteger } from '@cibo/ui'
import { Outlet } from 'react-router-dom'

interface UsersLayoutProps {}

export const UsersLayout = (props: UsersLayoutProps) => {
  const userId = useParamAsInteger('userId')
  const user = useOrgUser(userId)

  if (user.isInitialLoading) {
    return <Loading />
  }

  return <Outlet />
}
